// src/components/LoggedIn/InventarioMovements.jsx
import React, { useEffect, useState } from 'react';
import { getInventoryMovements } from '../../services/productsServices';
import '../../styles/InventarioMovements.css';

export default function InventarioMovements({ FIInventario }) {
  const [movimientos, setMovimientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtroProducto, setFiltroProducto] = useState('');
  const [filtroFecha, setFiltroFecha] = useState('');
  const [filtroTipo, setFiltroTipo] = useState('');

  useEffect(() => {
    setLoading(true);
    const fetchMovimientos = async () => {
      try {
        const data = await getInventoryMovements(FIInventario);
        const list = Array.isArray(data) ? data : data.movimientos || [];
        setMovimientos(list);
      } catch (err) {
        console.error('Error al obtener movimientos:', err);
        setMovimientos([]);
      } finally {
        setLoading(false);
      }
    };
    fetchMovimientos();
  }, [FIInventario]);

  const limpiarFiltros = () => {
    setFiltroProducto('');
    setFiltroFecha('');
    setFiltroTipo('');
  };

  const movimientosFiltrados = movimientos.filter(mov => {
    const nombre = mov.FIProducto?.FCNombre?.toLowerCase() || '';
    const tipo = mov.FITipoMovimiento || '';
    const fechaIso = new Date(mov.FDFechaMovimiento).toISOString().split('T')[0];
    return (
      (!filtroProducto || nombre.includes(filtroProducto.toLowerCase())) &&
      (!filtroTipo || tipo === filtroTipo) &&
      (!filtroFecha || fechaIso === filtroFecha)
    );
  });

  return (
    <div className="inventario-movements-container">
      <div className="filtros-ventas">
        <input
          type="text"
          placeholder="Buscar producto..."
          value={filtroProducto}
          onChange={e => setFiltroProducto(e.target.value)}
          className="input-filtro"
        />
        <input
          type="date"
          value={filtroFecha}
          onChange={e => setFiltroFecha(e.target.value)}
          className="input-filtro"
        />
        <select
          value={filtroTipo}
          onChange={e => setFiltroTipo(e.target.value)}
          className="input-filtro"
        >
          <option value="">Todos los movimientos</option>
          <option value="ENTRADA">ENTRADA</option>
          <option value="SALIDA">SALIDA</option>
          <option value="ALTA">ALTA</option>
          <option value="AJUSTE">AJUSTE</option>
        </select>
        <button
          className="boton-limpiar-filtros"
          onClick={limpiarFiltros}
        >
          Limpiar filtros
        </button>
      </div>

      {loading ? (
        <p className="mensaje-aviso">Cargando movimientos...</p>
      ) : movimientosFiltrados.length === 0 ? (
        <p className="mensaje-aviso">No hay movimientos que coincidan con los filtros.</p>
      ) : (
        <div className="table-responsive">
          <table className="movimientos-table">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Producto</th>
                <th>Cantidad</th>
                <th>Fecha</th>
                <th>Comentario</th>
              </tr>
            </thead>
            <tbody>
              {movimientosFiltrados.map(mov => (
                <tr key={mov.FIMovimiento}>
                  <td>{mov.FITipoMovimiento}</td>
                  <td>{mov.FIProducto.FCNombre}</td>
                  <td>{mov.FNCantidad}</td>
                  <td>{new Date(mov.FDFechaMovimiento).toLocaleString()}</td>
                  <td>{mov.FCComentario || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
